import React from 'react';
import './CardLayoutSection.css';

const CardLayoutSection = ({ generatedContent, previewMode }) => {
  if (!generatedContent || !generatedContent.content || generatedContent.content.length === 0) {
    return null;
  }

  const { title, content } = generatedContent;

  const renderCard = (card, index) => (
    <div key={index} className="card-layout-item">
      {card.image && <img src={card.image} alt={card.title || `Card ${index + 1}`} className="card-layout-image" />}
      <div className="card-layout-content">
        {card.title && <h3 className="card-layout-title">{card.title}</h3>}
        {card.text && <p className="card-layout-text">{card.text}</p>}
      </div>
    </div>
  );

  if (previewMode) {
    return (
      <div>
        <h2>{title}</h2>
        <div className="card-layout-container">
          {content.map(renderCard)}
        </div>
      </div>
    );
  }

  return (
    <div className="product-section">
      <div className="section-header">
        <div className="section-title">{title}</div>
      </div>
      <div className="section-content">
        <div className="card-layout-container">
          {content.map(renderCard)}
        </div>
      </div>
    </div>
  );
};

export default CardLayoutSection;
